import * as yup from 'yup'

export class VehicleCheckInFrontCornerPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    vehicleCheckInFrontCornerPhotoFile?: File = undefined
}

export const vehicleCheckInFrontCornerPhotoValidationSchema = yup.object({
  vehicleCheckInFrontCornerPhotoFile: yup.mixed().notRequired()
})
